module.exports = __webpack_public_path__ + "static/gif3.bf07af7d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/dtgif/gif3.gif
// module id = 541
// module chunks = 270958380025928